import { Autocomplete, createFilterOptions, InputAdornment, TextField } from "@mui/material";

const filter = createFilterOptions();
export default function InputField({ value, setValue, options=[], startAdornment='', isCustomisable=true, isNumeric=false }) {
    return (
        <Autocomplete
            freeSolo={isCustomisable}
            fullWidth
            autoSelect
            handleHomeEndKeys
            forcePopupIcon={options.length > 0} 
            options={options}
            value={value} 
            inputValue={value}
            onInputChange={(event, input_value, reason) => { // typed
                if (isCustomisable) setValue(v => {
                    let output = '';
                    if (reason === 'clear') output = '';
                    if (reason === 'input') {
                        const isExisting = options.some((option) => v === option.label);
                        if (isNumeric) output = !isNaN(input_value) ? input_value.trim() :  !isExisting ? input_value.trim().replace(/[^\d]/g, '') : v;
                        else output = input_value.trim();
                    }
                    return output;
                });
            }}
            onChange={(event, newValue) => { // selected
                let output = '';
                if (typeof newValue === 'string') { // option type == string
                    output = newValue;
                } else if (newValue && newValue.inputValue) { // custom typed input
                    output = newValue.inputValue;
                } else {
                    output = newValue?.label || ''; // selected option type == obj
                }
                setValue(output);
            }}
            filterOptions={(options, params) => {
                if (options.length > 0) {
                    const filtered = filter(options, params);
                    
                    if (isCustomisable) {
                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option) => inputValue === option.label);
                        if (!isExisting) {
                            filtered.unshift({
                                inputValue,
                                title: `Type a custom value: "${inputValue}"`,
                            });

                        }
                    }
                    return filtered;
                } else return options;
            }}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue !== undefined) {
                  return option.inputValue;
                }
                // Regular option
                return option.label ? option.label : option.value;
            }}
            renderOption={(props, option) => {
                const { key, id, ...optionProps } = props;
                return (
                    <li key={id} {...optionProps}>
                        {option?.title ? <i>{option.title}</i> : option?.label ? option.label : option.value }
                    </li>
                );
            }}
            renderInput={(params) =>
                <TextField 
                    {...params}
                    ref={params.InputProps.ref}
                    fullWidth
                    className='rounded-input' 
                    slotProps={{
                        input: {
                            startAdornment: (
                            <InputAdornment position="start" sx={{ px: 1 }}>{startAdornment}</InputAdornment>
                            ),
                            endAdornment: params.InputProps.endAdornment,
                        }
                    }}
                />
            }
        />
    )
}